import { useCallback } from 'react';
// Radix Dialog locks body scroll (react-remove-scroll), which `preventDefault`s wheel events on
// portaled Popover content rendered as a sibling of the dialog - so a dropdown opened inside a modal
// cannot be wheel-scrolled even though it is scrollable (programmatic scrolling still works). RRS
// only prevents the default, it does not stop propagation, so a `wheel` listener on the element can
// still scroll it manually. We attach via a CALLBACK ref (not an effect + ref object) because the
// portaled content mounts only when the popover opens; a callback ref fires exactly then, with the
// element. Harmless outside dialogs: it just scrolls the element and stops scroll-chaining to the
// page. Detached elements (popover closed) are garbage-collected with their listener.
export const useWheelScrollRef = () => useCallback((element) => {
    if (!element) {
        return;
    }
    const onWheel = (event) => {
        if (element.scrollHeight <= element.clientHeight) {
            return;
        }
        event.preventDefault();
        element.scrollTop += event.deltaY;
    };
    element.addEventListener('wheel', onWheel, { passive: false });
}, []);
